import React from 'react';
import { FaBookOpen, FaUsers, FaClock, FaShoppingCart, FaExclamationTriangle } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import { GameHero, GameSection, FAQAccordion, Footer } from '../../../shared/components';
import logoSvg from '../../../assets/bibliquien/logo.svg';
import * as S from './BibliQuienGamePage.styles';

const BibliQuienGamePage = () => {
  const t = useTranslation();

  const heroBadges = [
    { label: t('bibliquienGame.badges.physical'), variant: 'secondary' },
    { label: t('bibliquienGame.badges.status'), variant: 'primary' },
  ];

  const heroActions = [
    {
      label: t('bibliquienGame.actions.buy'),
      href: '/bibliquien/producto',
      variant: 'primary',
      icon: <FaShoppingCart />,
    },
    {
      label: t('bibliquienGame.actions.instructions'),
      href: '#instrucciones',
      variant: 'outline',
    },
  ];

  const instructionsSteps = t('bibliquienGame.instructions.steps', { returnObjects: true }) || [];
  const faqItems = t('bibliquienGame.faq.items', { returnObjects: true }) || [];
  const ruleItems = t('bibliquienGame.rules.items', { returnObjects: true }) || [];
  const characterList = t('bibliquienGame.characters.list', { returnObjects: true }) || [];

  return (
    <S.PageContainer>
      <GameHero
        title={t('bibliquienGame.hero.title')}
        subtitle={t('bibliquienGame.hero.subtitle')}
        badges={heroBadges}
        actions={heroActions}
        image={logoSvg}
        imageAlt={t('bibliquienGame.hero.imageAlt')}
      />

      {/* Description & Overview */}
      <GameSection
        title={t('bibliquienGame.overview.title')}
        subtitle={t('bibliquienGame.overview.subtitle')}
      >
        <S.GridThree>
          <S.InfoCard>
            <FaBookOpen />
            <S.CardTitle>{t('bibliquienGame.overview.cards.conceptTitle')}</S.CardTitle>
            <S.CardText>{t('bibliquienGame.overview.cards.conceptText')}</S.CardText>
          </S.InfoCard>

          <S.InfoCard>
            <FaUsers />
            <S.CardTitle>{t('bibliquienGame.overview.cards.playersTitle')}</S.CardTitle>
            <S.CardText>{t('bibliquienGame.overview.cards.playersText')}</S.CardText>
          </S.InfoCard>

          <S.InfoCard>
            <FaClock />
            <S.CardTitle>{t('bibliquienGame.overview.cards.durationTitle')}</S.CardTitle>
            <S.CardText>{t('bibliquienGame.overview.cards.durationText')}</S.CardText>
          </S.InfoCard>
        </S.GridThree>
      </GameSection>

      {/* Instructions */}
      <GameSection
        id="instrucciones"
        title={t('bibliquienGame.instructions.title')}
        subtitle={t('bibliquienGame.instructions.subtitle')}
        background="#ffffff"
      >
        <S.StepsContainer>
          {Array.isArray(instructionsSteps) && instructionsSteps.map((step, idx) => (
            <S.StepItem key={idx}>
              <S.StepNumber>{idx + 1}</S.StepNumber>

              <div>
                <S.CardTitle>{step.title}</S.CardTitle>
                <S.CardText>{step.description}</S.CardText>
              </div>
            </S.StepItem>
          ))}
        </S.StepsContainer>
      </GameSection>

      {/* Important Rules */}
      <GameSection
        title={t('bibliquienGame.rules.title')}
      >
        <S.GridTwo>
          {Array.isArray(ruleItems) && ruleItems.map((rule, idx) => (
            <S.InfoCard key={idx}>
              <FaExclamationTriangle />
              <S.CardText>{rule}</S.CardText>
            </S.InfoCard>
          ))}
        </S.GridTwo>
      </GameSection>

      {/* Characters */}
      <GameSection
        title={t('bibliquienGame.characters.title')}
        subtitle={t('bibliquienGame.characters.subtitle')}
        background="#ffffff"
      >
        <S.CharactersGrid>
          {Array.isArray(characterList) && characterList.map((character, idx) => (
            <S.CharacterChip key={idx}>{character}</S.CharacterChip>
          ))}
        </S.CharactersGrid>
      </GameSection>

      {/* FAQ */}
      <GameSection
        title={t('bibliquienGame.faq.title')}
        subtitle={t('bibliquienGame.faq.subtitle')}
      >
        <FAQAccordion items={Array.isArray(faqItems) ? faqItems : []} />
      </GameSection>

      {/* Commercial CTA */}
      <GameSection background="#ffffff">
        <S.CommercialCTA>
          <S.CTATitle>{t('bibliquienGame.cta.title')}</S.CTATitle>
          <S.CTAText>{t('bibliquienGame.cta.text')}</S.CTAText>
          <S.CTAButton href="/bibliquien/producto">
            {t('bibliquienGame.cta.buttonText')}
          </S.CTAButton>
        </S.CommercialCTA>
      </GameSection>

      <Footer />
    </S.PageContainer>
  );
};

export default BibliQuienGamePage;
